import { render, staticRenderFns } from "./TechnicalDocumentation.vue?vue&type=template&id=017dc7f2&scoped=true&"
import script from "./TechnicalDocumentation.vue?vue&type=script&lang=ts&"
export * from "./TechnicalDocumentation.vue?vue&type=script&lang=ts&"
import style0 from "./TechnicalDocumentation.vue?vue&type=style&index=0&id=017dc7f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017dc7f2",
  null
  
)

export default component.exports